import { render } from "./EMROrdersLogs.vue?vue&type=template&id=31d9fda4"
import script from "./EMROrdersLogs.vue?vue&type=script&lang=js"
export * from "./EMROrdersLogs.vue?vue&type=script&lang=js"

import "./EMROrdersLogs.vue?vue&type=style&index=0&id=31d9fda4&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/logs/EMROrdersLogs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "31d9fda4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('31d9fda4', __exports__)) {
    console.log('reload')
    api.reload('31d9fda4', __exports__)
  }
  
  module.hot.accept("./EMROrdersLogs.vue?vue&type=template&id=31d9fda4", () => {
    console.log('re-render')
    api.rerender('31d9fda4', render)
  })

}


export default __exports__